export default __webpack_public_path__ + "static/media/f1.53493ea6.jpg";